import { Api } from "../axios.config";

const path = "/behavior_templates";

export const getBehaviorTemplates = () => Api.get(`${path}`);
export const getBehaviorTemplate = (id) => Api.get(`${path}/${id}`);
export const getBehaviorTemplateStats = (id) => Api.get(`${path}/${id}/stats`);
export const addBehaviorTemplate = (id, payload) =>
  Api.post(`${path}/${id}/apply_to_bot/`, payload);
